import { useDrop } from "react-dnd";
import { Button } from "semantic-ui-react";
import React from "react";

interface DragItem {
  index: number
  id: string
  type: string
}

const LmsGroupByHeaderList = ({ currentViewGroups, setCurrentViewGroups, activeDragColumn }) => {

  const getCantDrop = () => {
    if (!currentViewGroups || !activeDragColumn?.prop) {
      return false;
    }
    else {
      return currentViewGroups.some(gi => gi.prop === activeDragColumn?.prop);
    }
  };

  const [{ isOver, canDrop }, drop] = useDrop<DragItem,
    void,
    { isOver: boolean, canDrop: boolean }>({
    accept: "card",
    drop: () => ({ isGroupBy: true }) as any,
    collect(monitor) {
      return {
        isOver: monitor.isOver(),
        canDrop: monitor.canDrop(),
      };
    },
  });

  const isActive = isOver && canDrop && !getCantDrop();
  const cantDropIsActive = isOver && getCantDrop();
  const style = isActive ? { backgroundColor: "#E4F9E7", border: "1px solid #54C144" } : cantDropIsActive ? {
    backgroundColor: "#FEE8E6",
    border: "1px solid #DC4D27"
  } : { border: "1px solid transparent" };

  return <div className="lms-table-group-by-list" style={style} ref={drop}>
    {(!currentViewGroups || (currentViewGroups?.length === 0)) && <span className="empty-placeholder">Drag a column header and drop it here to group by that column</span>}
    {currentViewGroups?.length > 0 && <>
      {currentViewGroups?.map(({ item, prop }, index: number) => {
        return (
          <Button.Group
            key={`${prop}_${index}`}
            className="table-group-by-list-button"
          >
            <Button
              compact
              disabled
            >
              {item}
            </Button>
            <Button
              compact
              onClick={() => {
                const filteredItems = currentViewGroups?.filter(gi => gi.prop !== prop);
                setCurrentViewGroups(filteredItems);
              }}
              icon="x"
            />
          </Button.Group>
        );
      })}
    </>}
  </div>;
};

export default LmsGroupByHeaderList;